module.exports = __webpack_public_path__ + "static/media/Timmy.afcf9aa0.png";